import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReservationFormResponse, ReservationGuest, ReservationTypeEnum, Filter, ReservationForm, ListData, ChangeReservationTable } from '../models/Reservation';

@Injectable({
  providedIn: 'root'
})
export class ReservationsService {

  refreshList = new BehaviorSubject<boolean>(false);
  closeDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  AllReservationVisualView(filter: Filter) {
    return this.http.post<ListData>(`${environment.apiUrl}/ResReservation/AllReservationVisualView`, filter);
  }
  saveRecord(data: ReservationForm) {
    if (data.reservationId) {
      return this.http.post<ReservationFormResponse>(`${environment.apiUrl}/ResReservation/ResEditReservation`, data);
    } else {
      return this.http.post<ReservationFormResponse>(`${environment.apiUrl}/ResReservation/ResAddNewReservation`, data);
    }
  }
  ResCheckReservation(data: ReservationForm) {
    return this.http.post<ReservationFormResponse>(`${environment.apiUrl}/ResReservation/ResCheckReservation`, data);
  }
  ResCheckUserRestaurant(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResCheckUserRestaurant?RestaurantId=${RestaurantId}`);
  }

  ResReservationChannels(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResReservationChannels?RestaurantId=${RestaurantId}`);
  }
  ResReservationEvents(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResReservationEvents?RestaurantId=${RestaurantId}`);
  }
  ResReservationDates(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservation/ResReservationDates`, data);
  }
  ResReservationPrefrences(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResReservationPrefrences?RestaurantId=${RestaurantId}`);
  }
  ResGetTags() {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResGetTags`);
  }
  ResFloorsList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResFloorsList?restaurantId=${restaurantId}`);
  }
  ResFloors(RestaurantId: number, ReservationDate: string, ReservationType: ReservationTypeEnum | string, floorId: number) {
    let data = {
      RestaurantId,
      ReservationDate,
      ReservationType,
      floorId
    };
    return this.http.post(`${environment.apiUrl}/ResReservation/ResFloors`, data);
  }
  ResCheckCustomer(RestaurantId: number, searchText: string) {
    return this.http.get<ReservationGuest>(`${environment.apiUrl}/ResReservation/ResCheckCustomer?RestaurantId=${RestaurantId}&searchText=${searchText}`);
  }
  AllReservation(filter: Filter) {
    return this.http.post(`${environment.apiUrl}/ResReservation/AllReservation`, filter);
  }
  GetReservationById(ReservationId?: any) {
    return this.http.get(`${environment.apiUrl}/ResReservation/GetReservationById?ReservationId=${ReservationId}`);
  }
  ResChangeReservationStatus(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservation/ResChangeReservationStatus`, data);
  }
  ResBlockTabel(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservation/ResBlockTabel`, data);
  }
  ResWaitersReservationList(RestaurantId: any, ReservationDate: any) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResWaitersReservationList?RestaurantId=${RestaurantId}&ReservationDate=${ReservationDate}`);
  }
  ResFloorsChangeTable(reservationId: number, floorId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResFloorsChangeTable?reservationId=${reservationId}&floorId=${floorId}`);
  }
  ResCheckReservationChangeTable(data: ChangeReservationTable) {
    return this.http.post<ReservationFormResponse>(`${environment.apiUrl}/ResReservation/ResCheckReservationChangeTable`, data);
  }
  ResEditReservationTable(data: ChangeReservationTable) {
    return this.http.post(`${environment.apiUrl}/ResReservation/ResEditReservationTable`, data);
  }
  ResReservationExtendDuration(reservationId: any, TotalNewTime: any) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResReservationExtendDuration?reservationId=${reservationId}&TotalNewTime=${TotalNewTime}`);
  }
}
